import { render, staticRenderFns } from "./StakingSummaryCard.vue?vue&type=template&id=2a8f4003&scoped=true"
import script from "./StakingSummaryCard.vue?vue&type=script&lang=js"
export * from "./StakingSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./StakingSummaryCard.vue?vue&type=style&index=0&id=2a8f4003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f4003",
  null
  
)

export default component.exports